export default __webpack_public_path__ + "static/media/NFO_PostLogin_Diversified_Fund_Hero_desktop.d3de0698.jpg";